<template>
    <div class="swiper-slide flex-column text-left">
        <div v-for="item in items" class="w-100">
            <div v-if="item.is_simple" class="checkbox filters__swiper-item justify-content-start">
                <input type="checkbox" :checked="isSimpleChecked(item)" @change="changeSimple($event, item)">
                <span class="checkbox__mark"></span>
                <label class="checkbox__label" v-text="item.title"></label>
            </div>

            <a v-else :href="'#' + (item.name || item.title)" class="filters__swiper-item" @click.prevent="$emit('click', $event)">
                <span v-text="item.title"></span>
                <i class="gbi-next font-weight-bolder"></i>
            </a>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            items: {
                type: Array,
                default: () => []
            }
        },

        methods: {
            isSimpleChecked(item) {
                return this.findSimple(item.name).checked
            },

            changeSimple(event, item) {
                let checkbox = this.findSimple(item.name)

                checkbox.checked = event.target.checked

                checkbox.dispatchEvent(new Event('change'))
            },

            findSimple(name) {
                let parts = name.split('='),
                    selector = `input[name="${parts[0]}"]`

                if (parts[1]) {
                    selector += `[value="${parts[1]}"]`
                }

                return this.$el.nextElementSibling.querySelector(selector)
            }
        }
    }
</script>